<template>
  <div>
    <LeftSidebar
      :visible="visible"
      :title="leftSidebarTitle"
      :hasBack="state === 'FORM'"
      bodyClass="overflow-y-hidden"
      titleClass="padding-x-16"
      :hasFooter="state === 'FORM'"
      @back="state === 'FORM' ? setState('LIST') : handleClose"
      @close="handleClose"
    >
      <div v-if="visible" class="height-percent-100">
        <ListWrapper
          v-if="state === 'LIST'"
          :url="url"
          :extraParams="{ resource: 'center_execute' }"
          :hasTitle="false"
          :hasAddButton="false"
          :isUseInSidebar="true"
          headerClass=""
          menuBarClass="padding-x-16"
          searchTxtClass="width-percent-100"
          wrapperClass="padding-y-16"
          @getPermissions="setPermissions"
          @getCount="setCount"
        >
          <template slot-scope="{ items, itemsLoading }">
            <LoadingWrapper :loading="itemsLoading">
              <template #loading>
                <ReportSettingLoading :count="10" />
              </template>
              <template #default>
                <b-row class="margin-0 padding-x-16">
                  <b-col
                    v-for="(item, index) in generateItems(items)"
                    :key="index"
                    cols="12"
                    class="border--solid border--complementary-50 border-radius-8 padding-x-12 padding-y-8 margin-bottom-8"
                  >
                    <b-row class="margin-0" align-h="between" align-v="center">
                      <b-col
                        cols=""
                        class="font-size-12 color-complementary-300 padding-0"
                      >
                        <div class="margin-bottom-8">
                          {{ item.caption }}
                        </div>
                        <div>{{ $lang.format }}: {{ item.formats }}</div>
                      </b-col>
                      <b-col cols="auto" class="padding-0">
                        <span
                          class="color-complementary-200 cursor--pointer"
                          @click="handleOpenEditForm(item)"
                        >
                          <mdicon name="pencil-outline" size="24" />
                        </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
            </LoadingWrapper>
          </template>
        </ListWrapper>
        <EditReportSettingForm
          v-if="state === 'FORM'"
          :data="currentEditItem"
          @handleClose="setState('LIST')"
        />
      </div>
    </LeftSidebar>
  </div>
</template>

<script>
import {
  LeftSidebar,
  ListWrapper,
  LoadingWrapper,
} from "@/components/re-design";
import ReportSettingLoading from "./ReportSettingLoading.vue";
import EditReportSettingForm from "./EditReportSettingForm.vue";
import { computed, ref, toRefs, watch } from "vue";
import { pathOr } from "ramda";
import { generateApiUrl, generateLang } from "@/shared/utils";

export default {
  components: {
    LeftSidebar,
    ListWrapper,
    LoadingWrapper,
    ReportSettingLoading,
    EditReportSettingForm,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    evidenceId: {
      type: [Number, String],
      default: null,
    },
  },
  setup(props, { emit }) {
    // bind props
    const { visible } = toRefs(props);

    const handleClose = () => emit("handleClose");

    const url = generateApiUrl(["globalServices", "reportSettings"]);

    // handle component state
    const state = ref("LIST");
    const setState = (value) => (state.value = value);

    // handle get data of list
    const permissions = ref([]);
    const setPermissions = (data) => (permissions.value = data);
    const reportSettingCount = ref(0);
    const setCount = (value) => (reportSettingCount.value = value);

    // handle left sidebar title
    const leftSidebarTitle = computed(() =>
      state.value === "LIST"
        ? `<span class="color-complementary-300">
          ${generateLang(["reportSetting"])}
          </span>
          <span class="color-complementary-200"> | 
          ${reportSettingCount.value}
          </span>`
        : `<span class="color-complementary-300">
          ${generateLang(["setReport"])}
          </span>`
    );

    // regenerate items with custom format
    const generateItems = (items) => {
      return items.map((item) => {
        return {
          id: pathOr(null, ["id"], item),
          caption: pathOr("", ["report_caption"], item),
          name: pathOr("", ["report_name"], item),
          formats: pathOr([], ["report_format"], item).join(", "),
          introduction: pathOr("", ["setting", "introduction"], item),
          logo: pathOr("", ["setting", "logo"], item),
        };
      });
    };

    // handle edit form
    const currentEditItem = ref(null);
    const handleOpenEditForm = (item) => {
      currentEditItem.value = item;
      setState("FORM");
    };

    // handle reset data when invisible component
    watch(visible, (value) => {
      if (!value) {
        setState("LIST");
        setCount(0);
      }
    });

    // return data to be used in template
    return {
      visible,
      url,
      handleClose,
      state,
      setState,
      permissions,
      setPermissions,
      setCount,
      leftSidebarTitle,
      generateItems,
      currentEditItem,
      handleOpenEditForm,
    };
  },
};
</script>
